/** Keys used for CRM auth / session (localStorage). */
export const CRM_AUTH_STORAGE_KEYS = [
  'jwt_token',
  'access_token',
  'cognito_access_token',
  'user',
  'cognito_user',
  'user_tenant',
  'user_role',
  'user_business_area',
  'login_token',
  'login_username',
  // Legacy keys still written by some layouts
  'isAuthenticated',
  'userEmail',
  'userTenant',
  'isAdmin',
] as const;

const CRM_SESSION_KEYS = [
  'post_auth_target',
  'post_auth_path',
  'spa_redirect_path',
] as const;

/** Remove all CRM auth tokens and routing stash (does not reload). */
export function clearCrmAuthSession(): void {
  if (typeof window === 'undefined') return;
  CRM_AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  CRM_SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
}

/** Full sign-out with hard navigation so mobile reload cannot restore jwt_token. */
export function signOutFromCrm(): void {
  clearCrmAuthSession();
  window.location.replace('/login');
}

/** True when a persisted API session token exists. */
export function hasStoredCrmAuthToken(): boolean {
  if (typeof window === 'undefined') return false;
  return Boolean(
    localStorage.getItem('jwt_token') ||
      localStorage.getItem('access_token') ||
      localStorage.getItem('cognito_access_token'),
  );
}
